<template>
  <sweet-modal ref="modal" title="Add a resource">
    <div class="form-group row">
      <label class="col-sm-5 col-form-label">Select type</label>
      <div class="col-sm-7">
        <select class="form-control" v-model="capability_type">
          <option :value="capabilityType" v-for="capabilityType in capability_types">{{ capabilityType | t }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row" v-if="capability_type_options.length > 0">
      <label class="col-sm-5 col-form-label">Select option</label>
      <div class="col-sm-7">
        <select class="form-control" v-model="selected_capability_option">
          <option :value="option" v-for="option in capability_type_options">{{ option.name }}</option>
        </select>
      </div>
    </div>
    <button class="btn btn-primary mt-4" @click="add_capability_column()" :disabled="is_button_active">
      {{ 'add' | t }}
    </button>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import Api from '@/store/jsonapi';

export default {
  props: [''],
  data: function () {
    return {
      capability_type_options: [],
      capability_types: ['order_channel_types', 'carrier_types'],
      capability_type: '',
      selected_capability_option: {}
    };
  },
  computed: {
    is_button_active() {
      return !(
        (this.capability_type === 'order_channel_types' || this.capability_type === 'carrier_types') &&
        !_.isEmpty(this.selected_capability_option)
      );
    }
  },
  methods: {
    async get_resource_types() {
      let { data } = await Api.findAllPages(this.capability_type, { fields: { [this.capability_type]: 'id,name' } });
      this.capability_type_options = data;
    },
    async add_capability_column() {
      // Fetch all fields for carrier type/order channel type
      let { data } = await Api.find(this.capability_type, this.selected_capability_option.id);
      this.selected_capability_option = data;

      this.$emit('add_cabability', this.selected_capability_option);
      this.close();
    },
    open: function (capability) {
      this.$refs.modal.open();
    },
    close: function () {
      this.$refs.modal.close();
    }
  },
  watch: {
    capability_type: function () {
      this.get_resource_types();
    }
  }
};
</script>
